<template>
  <table>
    <thead>
      <tr class="level-one-header">
        <th colspan="17">Fluid Properties and Contaminants</th>
      </tr>
      <tr class="level-two-header">
        <th class="sample-number">Lab ID</th>
        <th>Nitrites (ppm)</th>
        <th>Color</th>
        <th>Clarity</th>
        <th>D1287 pH</th>
        <th>Boil Pt.</th>
        <th>TDS</th>
        <th>Glycol %</th>
        <th>Freeze Pt.</th>
        <th>ELC</th>
        <th>Hardness</th>
        <th>Odor</th>
        <th>Mag Precip</th>
        <th>Non-Mag Precip</th>
        <th>Fuel</th>
        <th>Foam</th>
        <th>Oil</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(sample, index) in sampleData.coolantSamples" :key="`Secondary Table Sample ${index}`">
        <td>{{ sample.sampleNumber }}</td>
        <td :class="`severity-id-${sample.nitriteSeverity}`">{{ sample.nitriteDisplay }}</td>
        <td :class="`severity-id-${sample.colorSeverity}`">{{ sample.color }}</td>
        <td :class="`severity-id-${sample.claritySeverity}`">{{ sample.clarityResultName }}</td>
        <td :class="`severity-id-${sample.phSeverity}`">{{ sample.phDisplay }}</td>
        <td :class="`severity-id-${sample.boilPointSeverity}`">{{ sample.boilPointDisplay }}</td>
        <td :class="`severity-id-${sample.tdsSeverity}`">{{ sample.tdsDisplay }}</td>
        <td :class="`severity-id-${sample.antifreezePercentSeverity}`">{{ sample.antifreezePercent }}</td>
        <td :class="`severity-id-${sample.freezePointSeverity}`">{{ sample.freezePointDisplay }}</td>
        <td :class="`severity-id-${sample.elcPassFailSeverity}`">{{ sample.elcPassFail }}</td>
        <td :class="`severity-id-${sample.hardnessSeverity}`">{{ sample.hardnessDisplay }}</td>
        <td :class="`severity-id-${sample.odorSeverity}`">{{ sample.odor }}</td>
        <td :class="`severity-id-${sample.magneticPrecipitateSeverity}`">{{ sample.magneticPrecipitateResult }}</td>
        <td :class="`severity-id-${sample.nonMagneticPrecipitateSeverity}`">{{ sample.nonMagneticPrecipitateResult }}</td>
        <td :class="`severity-id-${sample.fuelSeverity}`">{{ sample.fuel }}</td>
        <td :class="`severity-id-${sample.foamSeverity}`">{{ sample.foam }}</td>
        <td :class="`severity-id-${sample.oilSeverity}`">{{ sample.oilResultName }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'CoolantSampleReportFluid',
  props: {
    sampleData: {
      type: Object,
      required: true
    }
  }
};
</script>
